
export default {
    props: {
        highlight: { type: Boolean, default: false },
        box: { type: Boolean, default: false },
        pointer: { type: Boolean, default: true },
        headline: { type: Boolean, default: false },
        hover: { type: Boolean, default: true },
        borderBottom: { type: Boolean, default: true },
        neonBg: { type: Boolean, default: false }
    },
};
